var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('p',{staticClass:"title is-5 has-text-centered"},[_vm._v("Policy Wordings")]),_c('policy-wording')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }